// content

export default function WebbLoaderMedium() {

  return (
  <>
    <div className="" style={{height:'10vh'}}></div>
    <div className="d-flex justify-content-center">
      <div className="spinner-border text-color-tint" role="status" style={{width: '2.4rem', height: '2.4rem', borderWidth:'0.06rem'}}>
        <span className="visually-hidden">loader...</span>
      </div>
    </div>

  </>
  )
}